import Reveal from "@/components/site/Reveal";

const LEADERS = [
  {
    name: "Mr. Burhan Gangardiwala",
    role: "Founder & Chairman",
    photo: "/images/founder.jpg",
    note: "With over two decades in construction and real estate, Mr. Burhan Gangardiwala founded Taha Developers on a simple belief — every family in Dahod deserves a home built on trust. Under his leadership, the company has delivered 15+ residential and commercial landmarks and earned the confidence of 250+ families, one address at a time.",
  },
  {
    name: "Mr. Taher Gangardiwala",
    role: "Managing Director",
    photo: "/images/leader-taher.jpg",
    note: "As Managing Director, Mr. Taher Gangardiwala shapes the strategy and standards of every Taha Developers project — from land selection to final handover. His sharp eye for quality and commitment to honest dealing ensure that each address carrying the family name stands as a benchmark of trust in the region.",
  },
  {
    name: "Mr. Taha Gangardiwala",
    role: "Managing Director",
    photo: "/images/leader-taha.jpg",
    note: "As Managing Director, Mr. Taha Gangardiwala drives the day-to-day excellence of Taha Developers — from on-site execution to customer relationships. Representing the next generation of the Gangardiwala family, he brings modern thinking and hands-on energy to every project, ensuring each address is delivered with the care the family name promises.",
  },
];

export default function Leadership() {
  return (
    <section id="leadership" className="max-w-7xl mx-auto px-6 lg:px-12 py-24 lg:py-32" data-testid="leadership-section">
      <Reveal>
        <div className="border-b border-white/10 pb-8 mb-14">
          <p className="font-accent text-xs tracking-[0.3em] uppercase text-[#C5A059] mb-3">03 — Leadership</p>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight" data-testid="leadership-title">
            The Vision <span className="gold-text italic">Behind the Name</span>
          </h2>
        </div>
      </Reveal>

      <div className="space-y-20">
        {LEADERS.map((leader, i) => (
          <Reveal key={leader.name} delay={0.05}>
            <div className={`grid lg:grid-cols-5 gap-12 lg:gap-20 items-start ${i > 0 ? "border-t border-white/10 pt-20" : ""}`}>
              <div className={`lg:col-span-2 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <div className="overflow-hidden border border-[#C5A059]/25 p-3 spotlight-frame group" data-testid={`leader-photo-frame-${i}`}>
                  <img
                    src={leader.photo}
                    alt={leader.name}
                    loading="lazy"
                    className="w-full aspect-[3/4] object-cover object-top group-hover:scale-105 transition-transform duration-[1.2s] ease-out"
                  />
                </div>
              </div>
              <div className={`lg:col-span-3 lg:pt-6 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                <h3 className="font-display text-3xl sm:text-4xl tracking-tight" data-testid={`leader-name-${i}`}>
                  {leader.name}
                </h3>
                <p className="mt-3 font-accent text-xs tracking-[0.3em] uppercase text-[#C5A059]" data-testid={`leader-role-${i}`}>
                  {leader.role}
                </p>
                <div className="mt-8 w-16 h-px bg-[#C5A059]/50" />
                <p className="mt-8 text-zinc-400 text-base leading-relaxed max-w-xl" data-testid={`leader-note-${i}`}>
                  {leader.note}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
